import React, { Component } from 'react';
import isEqual from 'lodash/isEqual';
import dayjs from '../../../../../dayjs/dayjs_timezone';
import RadioButtonList from '../../../../components/Common/RadioButtonList';
import Modal from '../../../../components/Modal';
import ClassesList from '../../ClassesList';
import Translation from '../../../../utilities/localizationUtility';
import Message from '../../../../components/Alert/message';
import { getTermOptions } from './helpers';
import ButtonForRadioList from './ButtonForRadioList';

export default class TermSelect extends Component {
  constructor(props) {
    super(props);

    this.state = {
      termOptions: getTermOptions(props),
      openedTermId: null,
    };

    this.setOpenFn = this.setOpenFn.bind(this);
    this.onButtonClick = this.onButtonClick.bind(this);
    this.renderRadioExtraContent = this.renderRadioExtraContent.bind(this);
    this.onChangeRadio = this.onChangeRadio.bind(this);
    this.handleModalClose = this.handleModalClose.bind(this);
  }

  componentDidMount() {
    const { termOptions } = this.state;
    const { onOptionsChange, setSelectedTerm } = this.props;
    const currentTerm = this.findTermFromParams(termOptions);

    onOptionsChange(termOptions);

    if (currentTerm) {
      setSelectedTerm(currentTerm);
    }
  }

  componentDidUpdate(oldProps) {
    const {
      flattenTimeSlots: oldFlattenTimeSlots,
      quantity: oldQuantity,
      selectedLocation: oldSelectedLocation,
      settings: oldSettings,
      variantSelected: oldVariantSelected,
    } = oldProps;
    const {
      onOptionsChange,
      setSelectedTerm,
      flattenTimeSlots,
      quantity,
      selectedLocation,
      settings,
      variantSelected,
    } = this.props;
    const oldTermOptions = getTermOptions(oldProps);
    const termOptions = getTermOptions(this.props);

    if (
      oldFlattenTimeSlots.length !== flattenTimeSlots.length
      || quantity !== oldQuantity
      || settings !== oldSettings
      || !isEqual(oldVariantSelected, variantSelected)
      || !isEqual(oldSelectedLocation, selectedLocation)
      || !isEqual(oldTermOptions, termOptions)
    ) {
      this.setState({ termOptions });
      onOptionsChange(termOptions);
    }

    if (
      !isEqual(oldVariantSelected, variantSelected)
      || !isEqual(oldSelectedLocation, selectedLocation)
      || !isEqual(oldTermOptions, termOptions)
    ) {
      const currentTerm = this.findCurrentTerm(termOptions);

      if (currentTerm) {
        setSelectedTerm(currentTerm);
      }
    }
  }

  findCurrentTerm(terms) {
    const { settings: { urlParams = {} }, termSelected } = this.props;
    const availableTerms = terms.filter((term) => (
      dayjs(term.start_date) <= dayjs().add(this.getAvailableDates(), 'days')));

    if (termSelected?.id) {
      const isIncludeTermSelectedId = availableTerms.map((t) => t.id).includes(termSelected.id);

      if (isIncludeTermSelectedId) {
        return termSelected;
      }
    }

    const firstAvailabilityOption = getTermOptions(this.props).find((o) => !o.disabled);

    if (!urlParams.start) {
      if (firstAvailabilityOption) {
        return availableTerms.find((term) => term.id === firstAvailabilityOption.id);
      }
      return availableTerms[0];
    }

    return this.findTermFromParams(terms) || availableTerms[0];
  }

  findTermFromParams(terms) {
    const { setUrlParam, settings: { urlParams = {} } } = this.props;

    if (!urlParams.start) {
      return null;
    }

    if (setUrlParam) {
      setUrlParam('start', null);
    }

    return terms.find((term) => dayjs(term.start_date).isSame(dayjs(urlParams.start)));
  }

  getAvailableDates() {
    let availableDates = 270; // default 9 months
    const { settings: { setting = {}, defaultSetting = {} } } = this.props;
    const maxNumberOfMonth = setting.max_number_of_months || defaultSetting.setting?.max_number_of_months;

    if (maxNumberOfMonth) {
      availableDates = 30 * maxNumberOfMonth;
    }

    return availableDates;
  }

  onButtonClick(termId) {
    this.setState({ openedTermId: termId }, () => {
      this.openModal();
    });
  }

  handleModalClose() {
    this.setState({ openedTermId: null });
  }

  renderRadioExtraContent({ id, disabled }) {
    const { settings } = this.props;

    return (
      <ButtonForRadioList
        optionId={id}
        settings={settings}
        onButtonClick={() => this.onButtonClick(id)} // TODO:
        disabled={disabled}
      />
    );
  }

  getFilteredTermOptions() {
    const { termOptions } = this.state;
    const { settings } = this.props;
    const { setting = {}, defaultSetting = {} } = settings;
    const maxNumberOfTerms = setting.max_number_of_terms || defaultSetting.setting?.max_number_of_terms;
    const availableDates = this.getAvailableDates();

    return termOptions.slice(0, parseInt(maxNumberOfTerms, 10)).filter((term) => {
      const startDate = dayjs(term.start_date);
      return startDate >= dayjs() && startDate <= dayjs().add(availableDates, 'days');
    });
  }

  onChangeRadio(value) {
    const { setSelectedTerm } = this.props;
    const termOptions = this.getFilteredTermOptions();

    setSelectedTerm(termOptions.find((x) => x.id === +value));
  }

  setOpenFn(openFn) {
    this.openModal = openFn;
  }

  renderContent(className) {
    const { termSelected, variantSelected, settings } = this.props;
    const { openedTermId } = this.state;

    if (!variantSelected) {
      return null;
    }

    const t = new Translation(settings);
    const termOptions = this.getFilteredTermOptions();

    return (
      <>
        <RadioButtonList
          className={className}
          name="terms"
          styled={settings.style.button}
          value={termSelected.id}
          options={termOptions}
          onChange={this.onChangeRadio}
          renderButton={this.renderRadioExtraContent}
        />

        <Modal
          title={t.key('classList')}
          getOpenFn={this.setOpenFn}
          portalClassName="classes-list"
          onAfterClose={this.handleModalClose}
        >
          <ClassesList termId={openedTermId} />
        </Modal>
      </>
    );
  }

  renderMessage() {
    const { loading, settings, style } = this.props;

    if (loading) {
      return null;
    }

    const t = new Translation(settings);
    const m = t.key('noScheduledEvents');

    return (
      <div className="text-center">
        <Message message={m} type="success" customStyle={style} />
      </div>
    );
  }

  render() {
    const { className } = this.props;
    const { termOptions } = this.state;
    const availableDates = this.getAvailableDates();
    const availableTermOptions = termOptions.filter(
      (term) => dayjs(term.start_date) <= dayjs().add(availableDates, 'days'),
    );

    return availableTermOptions.length ? this.renderContent(className) : this.renderMessage();
  }
}

TermSelect.displayName = 'TermSelect';
